import React from "react";
import { Button } from "@chakra-ui/react";

const commonBtnStyle = {
  width: "90.57%",
  height: "40px",
  alignSelf: "center",
  borderRadius: "4px",
  size: "md",
  fontFamily: "Poppins",
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "16px",
  color: "#FFFFFF",
};

const CustomButton = ({
  buttonLabel,
  onClick,
  backgroundColor = "#0E3665",
  ...props
}) => {
  return (
    <Button
      {...commonBtnStyle}
      onClick={onClick}
      backgroundColor={backgroundColor}
      {...props}
    >
      {buttonLabel}
    </Button>
  );
};

export default CustomButton;
